import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "content-card-ui"
    }}>{`Content Card UI`}</h1>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`iOS 15 (or newer)`}</li>
      <li parentName="ul">{`Xcode 15 (or newer)`}</li>
      <li parentName="ul">{`Swift 5.1 (or newer)`}</li>
    </ul>
    <h2 {...{
      "id": "api-reference"
    }}>{`API Reference`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./api-usage.md"
        }}>{`Content Card APIs`}</a></li>
    </ul>
    <h2 {...{
      "id": "public-classes-enums-and-protocols"
    }}>{`Public Classes, Enums, and Protocols`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/contentcardui.md"
        }}>{`Class - ContentCardUI`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/contentcardcustomizing.md"
        }}>{`Protocol - ContentCardCustomizing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/contentcarduieventlistening.md"
        }}>{`Protocol - ContentCardUIEventListening`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/contentcardtemplatetype.md"
        }}>{`Enum - ContentCardTemplateType`}</a></li>
    </ul>
    <h2 {...{
      "id": "templates"
    }}>{`Templates`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./templates/smallimage-template.md"
        }}>{`SmallImageTemplate`}</a></li>
    </ul>
    <h2 {...{
      "id": "ui-elements"
    }}>{`UI Elements`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./ui-elements/aeptext.md"
        }}>{`AEPText`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./ui-elements/aepbutton.md"
        }}>{`AEPButton`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./ui-elements/aepimage.md"
        }}>{`AEPImage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./ui-elements/aepstack.md"
        }}>{`AEPStack`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./ui-elements/aepdismissbutton.md"
        }}>{`AEPDismissButton`}</a></li>
    </ul>
    <h2 {...{
      "id": "tutorials"
    }}>{`Tutorials`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./tutorial/displaying-content-cards.md"
        }}>{`Fetch and Display Content Cards`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./tutorial/customizing-content-card-templates.md"
        }}>{`Customizing Content Card Templates`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./tutorial/listening-content-card-events.md"
        }}>{`Listening to Content Card Events`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      